import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormRadioGroup } from 'components/molecules/FormRadioGroup';
import { FormInput } from 'components/molecules/FormInput';
import { initialShotgunDetailsStepFormValues } from 'models/forms/applicationForm';
import ApplicationStore from 'state/ApplicationStore';
import { EDictionaryTypes } from 'models/dictionary';
import {
  StyledStepTitle,
  StyledSectionTitle,
  StyledParagraph,
} from 'pages/MyApplicationsPage/ApplicationDetailsPage/ApplicationDetailsStep/WizardSteps/styles';
import { useApplicationDetails } from 'pages/MyApplicationsPage/ApplicationDetailsPage/ApplicationDetailsStep/hooks';

const ShotgunDetailsStep = () => {
  const { loadDictionaries } = useApplicationDetails();

  const {
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initialShotgunDetailsStepFormValues,
  });

  useEffect(() => {
    (async function initDictionaries() {
      await loadDictionaries([EDictionaryTypes.Make]);
    })();
  }, []);

  useEffect(() => {
    const formData = ApplicationStore.getStepData('shotgunData');
    if (Object.keys(formData).length > 0) {
      reset(formData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ marginTop: '24px' }}>
      <StyledStepTitle variant="h4">Shotgun details</StyledStepTitle>
      <StyledParagraph variant="body2">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum
        laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin
        sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes,
        nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus
        mollis orci, sed rhoncus pronin sapien nunc accuan eget.
      </StyledParagraph>

      <StyledSectionTitle variant="h5">Current Shotgun</StyledSectionTitle>
      <StyledParagraph variant="body2">Details of shotguns currently held.</StyledParagraph>

      <form>
        <Box>
          <FormRadioGroup
            name="holdShotgun"
            label="Do you hold currently any shotguns? If YES, specify details"
            options={[
              { label: 'YES', value: '1' },
              { label: 'NO', value: '0' },
            ]}
            control={control}
            errors={errors}
          />
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <FormInput
                name="calibre"
                label="Calibre/Bore"
                control={control}
                errors={errors}
              />
            </Grid>
            <Grid item xs={4}>
              <FormInput
                name="actionType"
                label="Action/Type"
                required
                control={control}
                errors={errors}
              />
            </Grid>
            <Grid item xs={4}>
              <FormInput name="make" label="Make" required control={control} errors={errors} />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <FormInput
                name="serialNumber"
                label="Serial Number"
                control={control}
                errors={errors}
              />
            </Grid>
          </Grid>
        </Box>

        <StyledSectionTitle variant="h5">Security Arrangements</StyledSectionTitle>
        <StyledParagraph variant="body2">
          Details of current (or proposed) security arrangements.
        </StyledParagraph>
        <StyledParagraph variant="body2">
          Please allow the police to inspect your guns and security when requested as in the
          absence of a warrant consent is required for the police to inspect premises.
        </StyledParagraph>

        <Box>
          <FormRadioGroup
            name="securityArrangements"
            label="Are the security arrangements at one address?"
            options={[
              { label: 'YES', value: '1' },
              { label: 'NO', value: '0' },
            ]}
            control={control}
            errors={errors}
          />

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormInput
                name="securityDetails"
                label="If NO, provide details"
                control={control}
                errors={errors}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={4}>
              <FormInput
                name="securityType"
                label="Type of Security"
                control={control}
                errors={errors}
              />
            </Grid>
            <Grid item xs={8}>
              <FormInput
                name="securityAdditionalInformation"
                label="Additional Information"
                control={control}
                errors={errors}
              />
            </Grid>
          </Grid>

          <FormRadioGroup
            name="certificateHolder"
            label="Is the security shared with another certificate holder?"
            options={[
              { label: 'YES', value: '1' },
              { label: 'NO', value: '0' },
            ]}
            control={control}
            errors={errors}
          />

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormInput
                name="certificateDetails"
                label="If YES, provide details"
                control={control}
                errors={errors}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormInput
                name="ammoStorage"
                label="Ammunition Storage - Please provide details"
                control={control}
                errors={errors}
              />
            </Grid>
          </Grid>
        </Box>
      </form>
    </Box>
  );
};

export default ShotgunDetailsStep;
